export default __webpack_public_path__ + "static/media/LogoEnColor4.73ad6458.png";